/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type IdentifyAndClaimInStoreOrderInput = {
  /** ISO Format, e.g. 2024-01-15T10:30:00Z */
  readonly date: string;
  /** POS if alphanumeric, Kiosk otherwise */
  readonly orderId: string | number;
  /** Only numbers, may begin with 0 */
  readonly restaurantZip: string;
  /** Total in cents */
  readonly total: number;
};

export type IdentifyAndClaimInStoreOrderMutationVariables = Exact<{
  input: Types.IdentifyAndClaimInStoreOrderInput;
}>;

export type IdentifyAndClaimInStoreOrderMutation = {
  readonly identifyAndClaimInStoreOrder:
    | { readonly __typename: 'IdentifyAndClaimInStoreOrderSuccess'; readonly success: boolean }
    | { readonly __typename: 'ReceiptAlreadyClaimedError'; readonly errorMessage: string }
    | { readonly __typename: 'TimeRestrictionError'; readonly errorMessage: string }
    | { readonly __typename: 'TransactionNotFoundError'; readonly errorMessage: string };
};

export const IdentifyAndClaimInStoreOrderDocument = gql`
  mutation IdentifyAndClaimInStoreOrder($input: IdentifyAndClaimInStoreOrderInput!) {
    identifyAndClaimInStoreOrder(input: $input) {
      __typename
      ... on IdentifyAndClaimInStoreOrderSuccess {
        success
      }
      ... on TimeRestrictionError {
        errorMessage
      }
      ... on ReceiptAlreadyClaimedError {
        errorMessage
      }
      ... on TransactionNotFoundError {
        errorMessage
      }
    }
  }
`;

export function useIdentifyAndClaimInStoreOrderMutation() {
  return Urql.useMutation<
    IdentifyAndClaimInStoreOrderMutation,
    IdentifyAndClaimInStoreOrderMutationVariables
  >(IdentifyAndClaimInStoreOrderDocument);
}
